import {css} from "@panda/css";

import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

import {SeoMainHeadline} from "../../../atoms/SeoMainHeadline";
import {IVendorDetail} from "../../types/IVendorDetail";

interface IProps {
    vendor: IVendorDetail;
}

export const VendorDetailHeader = (props: IProps) => {
    const {vendor} = props;

    return (
        <div className={vendorDetailHeaderBase}>
            <Image alt={`${vendor.name} logo`} src={vendor.logo.v_log_120x90} width="120" height="90" className={logoStyles} />

            <div>
                <SeoMainHeadline as="h1" variant="headline_2" className={vendorNameStyle}>
                    {vendor.name}
                </SeoMainHeadline>

                {vendor.headquarters && (
                    <Text as="address" variant="body_copy_1" color="var(--colors-gray-600)">
                        {vendor.headquarters.region.short_name}, {vendor.headquarters.address}
                    </Text>
                )}
            </div>
        </div>
    );
};

const vendorDetailHeaderBase = css({
    display: "flex",
    flexDirection: "row"
});

const logoStyles = css({
    flex: "0 0 auto",
    alignSelf: "center",
    mr: 2,
    height: "6rem",

    "& > img": {
        width: "auto",
        height: "100%"
    },

    md: {
        height: "10rem"
    }
});

const vendorNameStyle = css({
    pt: 0.5,
    pb: 0.5,

    md: {
        pt: 1,
        pb: 2
    }
});
import {css} from "@panda/css";

import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

import {SeoMainHeadline} from "../../../atoms/SeoMainHeadline";
import {IVendorDetail} from "../../types/IVendorDetail";

interface IProps {
    vendor: IVendorDetail;
}

export const VendorDetailHeader = (props: IProps) => {
    const {vendor} = props;

    return (
        <div className={vendorDetailHeaderBase}>
            <Image alt={`${vendor.name} logo`} src={vendor.logo.v_log_120x90} width="120" height="90" className={logoStyles} />

            <div>
                <SeoMainHeadline as="h1" variant="headline_2" className={vendorNameStyle}>
                    {vendor.name}
                </SeoMainHeadline>

                {vendor.headquarters && (
                    <Text as="address" variant="body_copy_1" color="var(--colors-gray-600)">
                        {vendor.headquarters.region.short_name}, {vendor.headquarters.address}
                    </Text>
                )}
            </div>
        </div>
    );
};

const vendorDetailHeaderBase = css({
    display: "flex",
    flexDirection: "row"
});

const logoStyles = css({
    flex: "0 0 auto",
    alignSelf: "center",
    mr: 2,
    height: "6rem",

    "& > img": {
        width: "auto",
        height: "100%"
    },

    md: {
        height: "10rem"
    }
});

const vendorNameStyle = css({
    pt: 0.5,
    pb: 0.5,

    md: {
        pt: 1,
        pb: 2
    }
});
